/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class UpdateSamlIdentityProviderInput {
  /**
  * The SSO URL of the identity provider
  */
  'ssoUrl': string;
  /**
  * The logout URL of the identity provider
  */
  'logoutUrl'?: string;
  /**
  * The issuer URL of the identity provider
  */
  'issuerUrl': string;
  /**
  * The certificate of the identity provider
  */
  'certificate': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "ssoUrl",
      "baseName": "ssoUrl",
      "type": "string",
      "format": ""
    },
    {
      "name": "logoutUrl",
      "baseName": "logoutUrl",
      "type": "string",
      "format": ""
    },
    {
      "name": "issuerUrl",
      "baseName": "issuerUrl",
      "type": "string",
      "format": ""
    },
    {
      "name": "certificate",
      "baseName": "certificate",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateSamlIdentityProviderInput.attributeTypeMap;
  }

  public constructor() {
  }
}

